import { render, staticRenderFns } from "./VxSidebarItem.vue?vue&type=template&id=52b4260b&lang=pug"
import script from "./VxSidebarItem.vue?vue&type=script&lang=js"
export * from "./VxSidebarItem.vue?vue&type=script&lang=js"
import style0 from "./VxSidebarItem.vue?vue&type=style&index=0&id=52b4260b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports